import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import Statistics from "../../components/Statistics/Statistics";
import "./Dashboard.css";

export default function Dashboard() {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-content">
        <h1>Admin Dashboard</h1>
        <Statistics />
      </main>
    </div>
  );
}
